import { render } from "./App.vue?vue&type=template&id=24652346"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=24652346&lang=css"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__